import { FormCard } from "./FormCard"
import { Checkbox } from "@vesatogo/grass-core"

const TDSComponent = ({
    checked,
    setChecked,
    departmentConfig,
    disabled = false
}: {
    checked: boolean
    setChecked: (checked: boolean) => void
    departmentConfig: any
    disabled?: boolean
}) => {
    return (
        <FormCard
            title="TDS Information"
            childrenClassName="flex flex-col gap-0"
        >
            <div className="flex items-start gap-1 p-3 bg-blue-50 border border-blue-200 rounded-lg">

                <Checkbox
                    checked={checked}
                    disabled={disabled}
                    onChange={() => setChecked(!checked)}
                />

                <p className="text-sm text-gray-900 font-500 leading-relaxed">
                    Trade amount exceeds the TDS limit for this Supplier. If applied, {departmentConfig?.seller_tds_percentage}% TDS will be deducted from the trade amount payable to the Supplier.
                </p>
            </div>
        </FormCard>
    )
}

export default TDSComponent